import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/recurso/importer/recursoImporterActions';

export default importerReducers(actions);
